import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 58E0112F-0E05-4C53-8AF2-663009045010
 * name clock-time-six
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clock-time-six.svg
 * tags
 * - Date / Time 
 */
export const ClockTimeSixIcon = createSvgIcon(<><path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M12.5 17H11V7H12.5V17Z" /></>, 'ClockTimeSixIcon');
export default ClockTimeSixIcon